import { CurrencyCode } from '~/generated/graphql';
import { ProductCardProps } from './ProductCard';

export function Price({
  priceWithTax,
  currencyCode,
  variant = 'standard',
}: {
  priceWithTax?: number | ProductCardProps['priceWithTax'];
  currencyCode?: ProductCardProps['currencyCode'];
  variant?: 'standard' | 'primary';
}) {
  if (priceWithTax == null || !currencyCode) {
    return <></>;
  }

  const value = typeof priceWithTax === 'number'
    ? priceWithTax
    : 'value' in priceWithTax
      ? priceWithTax.value
      : 'min' in priceWithTax && priceWithTax.min === priceWithTax.max
        ? priceWithTax.min
        : null;

  if (value !== null) {
    return (
      <div className="inline-flex items-center">
        {currencyCode === 'NPR' ? (
          <span className={`mr-0.5 ${variant === 'primary' ? 'text-primary' : ''}`}>रु</span>
        ) : null}
        <span>{formatPriceValue(value, currencyCode)}</span>
      </div>
    );
  }

  // Handle range
  const priceRange = priceWithTax as { min: number; max: number };
  return (
    <div className="inline-flex items-center gap-1">
      <div className="inline-flex items-center">
        {currencyCode === 'NPR' ? (
          <img
            src={variant === 'primary' ? "/रू primary.png" : "/रू.svg"}
            alt="रु"
            className="h-[0.75em] w-auto"
          />
        ) : null}
        <span>{formatPriceValue(priceRange.min, currencyCode)}</span>
      </div>
      <span>-</span>
      <div className="inline-flex items-center">
        {currencyCode === 'NPR' ? (
          <span className={`mr-0.5 ${variant === 'primary' ? 'text-primary' : ''}`}>रु</span>
        ) : null}
        <span>{formatPriceValue(priceRange.max, currencyCode)}</span>
      </div>
    </div>
  );
}

export function formatPriceValue(value: number, currency: CurrencyCode) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  if (currency !== 'NPR') {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    }).format(value / 100);
  }

  return formatter.format(value / 100);
}

export function formatPrice(value: number, currency: CurrencyCode) {
  if (currency === 'NPR') {
    return `रु${formatPriceValue(value, currency)}`;
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
  }).format(value / 100);
}
